/* eslint-disable @typescript-eslint/no-explicit-any */
const Precio = ({form , setForm} : any) => {


  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.target.name) {
      case "price": {
        setForm({
          ...form,
          [e.target.name]: e.target.value
        })
      } break;
      default:
        break;
    }
  }

  return (
    <div className="h-[100%] flex justify-center items-center">
      <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-primary mb-2 block">Ahora, fijá tu precio</span>
        <span className="block">Podés cambiarlo cuando quieras.</span>

        <input type="text" className="border-0 w-full text-6xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
          value={form.price}
          name="price"
          onChange={(event) => onChange(event)} />

        <span className="block">Precio para viajero (Con impuestos): ${parseFloat(form.price) + (form.price / 100 * 20) }</span>
      </div>
      <div></div>
    </div></div>
  )
}

export default Precio